import { useContentSelector } from '@wajeez-web/stores/content';

export const useCollectionComponentsBodyLookups = () => {
  return useContentSelector(
    ({ collectionComponents }) =>
      collectionComponents.collectionComponentBodyLookups
  );
};

export const useCollectionComponentsStandAloneLookups = () => {
  return useContentSelector(
    ({ collectionComponents }) =>
      collectionComponents.collectionComponentStandAloneLookups
  );
};

export const useGetCollectionComponentByIdMultilingual = () => {
  return useContentSelector(
    ({ collectionComponents }) => collectionComponents.byIdMultilingual
  );
};

export const useCreateCollectionComponentByTypeIdMultilingual = () => {
  return useContentSelector(
    ({ collectionComponents }) => collectionComponents.createMultilingual
  );
};

export const useEditCollectionComponentMultilingual = () => {
  return useContentSelector(
    ({ collectionComponents }) => collectionComponents.editMultilingual
  );
};
